var pdpBreadCrumbsModule = (function () {
    var breadCrumbContainer = document.querySelector('.js-pdp-breadcrumbs');
    var breadCrumbCollectionURL = breadCrumbContainer.getAttribute('data-collection-url');
    var breadCrumbLinks = [];
    var breadCrumbPath = findBreadCrumbPath(breadCrumbCollectionURL, pdpBreadCrumbMenu.menu);

    function init() {
      createBreadCrumbLinks(breadCrumbPath);
      renderBreadCrumbLinks(breadCrumbLinks);
      checkTopLevelMenuActiveState(breadCrumbPath);
    }
    
    
    function findBreadCrumbPath(url, links) {
      return _.filter(links, link => {
        if (_.isEqual(_.toLower(link.url), _.toLower(url))) {
          return true;
        } else if (link.links) {
          link.links = findBreadCrumbPath(url, link.links);
          return !_.isEmpty(link.links);
        }
      });
    }

    function createBreadCrumbLinks(menuItem) {
      if (!menuItem.length) {
        return;
      }

      if (menuItem.length) {
        breadCrumbLinks.push({
          name: menuItem[0].name,
          url: menuItem[0].url
        });
      }

      if (menuItem[0].links && menuItem[0].links.length === 1) {
        createBreadCrumbLinks(menuItem[0].links)
      }
    }

    function renderBreadCrumbLinks(links) {
      var markup = `
      <nav aria-label="Breadcrumb" class="breadcrumb">
        <ol class="breadcrumb__list" itemscope itemtype="http://schema.org/BreadcrumbList">
          <li class="breadcrumb__item" itemprop="itemListElement" itemscope itemtype="http://schema.org/ListItem">
          <a class="breadcrumb__link link" href="/" itemprop="item">
          <span itemprop="name">Home</span>
          </a>
          <meta itemprop="position" content="1" />
          </li>
          <span class="pdp-breacrumbs__separator">\›</span>
          ${links.length ? getBreadCrumbs(links) : getBreadCrumbs([{name: 'All Products', url: '/collections/all'}])}
          <span class="pdp-breacrumbs__separator">\›</span>
          <li class="breadcrumb__item" itemprop="itemListElement" itemscope itemtype="http://schema.org/ListItem">
          <a class="breadcrumb__link link" href="${breadCrumbContainer.getAttribute('data-product-url')}" itemprop="item" aria-current="page" >
          <span itemprop="name">${breadCrumbContainer.getAttribute('data-product-title')}</span>
          </a>
          <meta itemprop="position" content="${links.length + 2}" />
          </li>
        </ol>
      </nav> 
      `;
      breadCrumbContainer.innerHTML = markup;
    }

    function getBreadCrumbs(links) {
      const delimiter = ' - ';
      const markup = links.map((link, index) => {
        return (
          `<li class="breadcrumb__item" itemprop="itemListElement" itemscope itemtype="http://schema.org/ListItem">
          <a class="breadcrumb__link link" href="${link.url}" itemprop="item">
          <span itemprop="name">${link.name.split(delimiter)[0]}</span>
          <meta itemprop="position" content="${index + 2}" />
          </a>
          </li>`
        )
      }).join('<span>\›</span>');

      return markup;
    }

    function checkTopLevelMenuActiveState(breadCrumbPath) {
      var topLevelNavLinks = document.querySelectorAll('.nav-bar__link');

      topLevelNavLinks.forEach(function(link) {
        if (link.href.indexOf(breadCrumbPath[0].url) > 0) {
          link.parentNode.classList.add('nav-bar__item--active')
        }
      })
    }

    
    return {
      init: init
    };

})();

pdpBreadCrumbsModule.init();
